import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { PermissionsResponse } from '@/apis/permissions';

interface PermissionsState {
  data: PermissionsResponse | null;
  /** Role and acting-on-behalf mode the payload was fetched for. Null when a test or caller sets data directly. */
  sessionKey: string | null;
}

const initialState: PermissionsState = {
  data: null,
  sessionKey: null,
};

export const permissionsSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    setPermissions: (state, action: PayloadAction<PermissionsResponse>) => {
      state.data = action.payload;
      state.sessionKey = null;
    },
    setPermissionsForSession: (
      state,
      action: PayloadAction<{ data: PermissionsResponse; sessionKey: string }>
    ) => {
      state.data = action.payload.data;
      state.sessionKey = action.payload.sessionKey;
    },
    clearPermissions: (state) => {
      state.data = null;
      state.sessionKey = null;
    },
  },
});

export const { setPermissions, setPermissionsForSession, clearPermissions } =
  permissionsSlice.actions;
export default permissionsSlice.reducer;
